module.exports = __webpack_public_path__ + "static/media/filter-white-icon.6b7212ea.svg";